__turbopack_context__.v({
  "container": "Loader-module-scss-module__nHZC_q__container",
  "loader": "Loader-module-scss-module__nHZC_q__loader",
  "message": "Loader-module-scss-module__nHZC_q__message",
  "overlay": "Loader-module-scss-module__nHZC_q__overlay",
  "spin": "Loader-module-scss-module__nHZC_q__spin",
  "spinner": "Loader-module-scss-module__nHZC_q__spinner",
});
